import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Compass } from "lucide-react";
import SignalCard from "./SignalCard";
import api from "../lib/api";
import { logError } from "../lib/logger";

export function BiasSignalsModal({ bias, open, onClose }) {
  const [signals, setSignals] = useState([]);
  const [loading, setLoading] = useState(false);
  const dir = (bias?.direction || "BUY").toUpperCase();
  const isBuy = dir === "BUY";

  useEffect(() => {
    if (!open || !bias?.id) return;
    setLoading(true);
    api.get(`/bias/${bias.id}/signals`)
      .then((r) => setSignals(r.data?.signals || []))
      .catch((e) => logError("Errore segnali bias:", e))
      .finally(() => setLoading(false));
  }, [open, bias?.id]);

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent data-testid="bias-signals-modal" className="max-w-3xl bg-[#0d0d0d] border-white/10 text-white max-h-[88vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className={`flex items-center gap-2 ${isBuy ? "text-emerald-400" : "text-red-400"}`}>
            <Compass size={18} /> GENERAL BIAS: {dir}
            {bias && <span className="text-sm text-zinc-400 font-normal">· {bias.symbol} ({bias.timeframe})</span>}
          </DialogTitle>
        </DialogHeader>
        <p className="text-xs text-zinc-500 -mt-1">
          I due segnali delle due strategie che hanno originato questa bias direzionale.
        </p>
        {loading ? (
          <div className="text-center py-16 text-zinc-500 text-sm">Caricamento segnali...</div>
        ) : signals.length === 0 ? (
          <div data-testid="bias-signals-empty" className="text-center py-16 text-zinc-500 text-sm">
            I segnali originari non sono più disponibili.
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
            {signals.map((s) => (
              <SignalCard key={s.id} s={s} onToggleFavorite={() => {}} />
            ))}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
